import { Button } from "primereact/button";
import React from "react";

const CardPlan = ({ plan, user, modules, savePlan, handleSelect, quantity, handleFree }) => {
  return (
    <div
      key={plan.id}
      className={`col-xl-3 col-md-6 py-3 h-100 pricing-card ${quantity > 4 ? "mx-3" : ""}`}
    // className={`col-xl-3 col-md-6 py-3 h-100 pricing-card ${
    //   plan.highlighted === 0 ? "py-xl-5" : ""
    // }`}
    >
      <div
        className={`card bg-dark-400 border-0 rounded-4 h-100`}
        style={
          (!user && plan.highlighted === 1) || (user && plan.currentPlan)
            ? {
              background:
                "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,185,167,1) 0%, rgba(114,212,202,1) 100%)",
              overflow: "hidden",
            }
            : {}
        }
      >
        <div className="card-body fs-14px p-30px d-flex flex-column position-relative">
          {!user && plan.highlighted === 1 && !plan.free_trial_days && (
            <div className="ribbon">Mais Vendido!</div>
          )}
          <div className="d-flex align-items-center">
            <div className="flex-1">
              <div className="h5 text-white font-monospace">{plan.name}</div>
              <div className="display-6 text-white fw-bold mb-0">
                {plan.free_trial_days ? (
                  <>
                    GRÁTIS {" "}
                  <small className="h5 text-gray-100 text-opacity-50">
                    por {plan.free_trial_days} dias
                  </small>
                  </>
                ) : (
                  <>
                  R$ {plan.value_total}{" "}
                  <small className="h5 text-gray-100 text-opacity-50">
                    /mês*
                  </small>
                  </>
                )}
              </div>
            </div>
          </div>
          {plan.currentPlan ? (
            <Button
              label="Plano Atual"
              disabled
              className="w-100 border border-0 button-card"
            // onClick={() => savePlan(plan.id)}
            />
          ) : user ? (
            <Button
              label="Alterar Plano"
              className="w-100 border border-0 button-card"
            // onClick={() => savePlan(plan.id)}
            />
          ) : (
            <Button
              label={plan.free_trial_days ? "Começe agora" : "Assinar"}
              className="w-100 text-black border border-0 button-card mt-4"
              onClick={() => handleSelect(plan)}
            />
          )}
          <hr className="my-4 text-white" />
          <div className="mb-5 text-body text-opacity-75 flex-1">
            {modules?.map((module) => (
              <div key={module.id} className="d-flex align-items-center mb-1">
                {plan.modules?.some(
                  (planModule) => planModule.name === module.name
                ) ? (
                  <>
                    <i className="fa fa-check fa-lg text-white"></i>
                    <div className="flex-1 ps-3">
                      <span className="font-monospace small text-gray-100">
                        {module.name}
                      </span>{" "}
                      <b className="text-white"></b>
                    </div>
                  </>
                ) : (
                  <>
                    <i className="fa fa-times fa-lg text-white text-opacity-25"></i>
                    <div className="flex-1 ps-3">
                      <span className="font-monospace small text-decoration-line-through text-gray-100">
                        {module.name}
                      </span>{" "}
                      <b className="text-white"></b>
                    </div>
                  </>
                )}
              </div>
            ))}
            {plan.plan_desc.map((d, index) => (
                <div key={index} className="d-flex align-items-center mb-1">
                  <i className="fa fa-check fa-lg text-white"></i>
                  <div className="flex-1 ps-3">
                    <span className="font-monospace small text-gray-100">
                      {d}
                    </span>{" "}
                    <b className="text-white"></b>
                  </div>
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardPlan;
